/*
 * Blurred preview of the image partial (components/media/image.html.twig): while an <img class="image--preview">
 * loads, its 24px background is blurred (_images.scss); once the image is there it gets "is-loaded" and the blur fades out.
 * The blur only applies with this script running (html.image-preview-ready), so an image never stays blurred without it.
 */
const markLoaded = (image) => {
    if (image.complete && image.naturalWidth > 0) {
        image.classList.add('is-loaded');
    }
};

export default function initImagePreview() {
    // load does not bubble, but it can be caught on the way down
    document.addEventListener('load', (event) => {
        if (event.target instanceof HTMLImageElement && event.target.classList.contains('image--preview')) {
            event.target.classList.add('is-loaded');
        }
    }, true);
    // images that were there before this script (cache, eager)
    document.querySelectorAll('img.image--preview').forEach(markLoaded);
    document.documentElement.classList.add('image-preview-ready');
}
